<template>
  <div v-if="langues.length > 1" id="languageSwapper" class="text-right py-3">
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn text color="primary" dark v-bind="attrs" v-on="on">
          {{ currentLang }}
          <v-icon class="ml-3"> mdi-menu-down </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="langue in langues.filter((l) => l.name !== currentLang)" :key="langue.code" link @click="switchLanguage(langue.name)">
          <v-list-item-title>{{ langue.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
  computed: {
    ...mapGetters(["langues", "currentLang", "paramsMultilingue", "traductions"])
  },
  methods: {
    ...mapActions(["setCurrentLang"]),
    switchLanguage(langue) {
      localStorage.setItem("Langue_Formulaire_Don_FUS_SRDD", langue)
      this.setCurrentLang(langue)
    }
  }
}
</script>

<style>
</style>